import React, { FC, ReactNode } from 'react'
import { StateProvider } from '@store'
import { Homepage as Page } from './Page'
import {LeadgenPopupType} from "@components/LeadgenPopupFlow";

export type Props = {
  mode: string
  pathname: string
  pagename: string
  children?: ReactNode
  phoneMapping: PhoneMapping
  pageData: any
  hideLogoTagline?: boolean
  infoBlockActionType?: 'MEDADV' | 'MEDSUP' | 'AUTO_INSURANCE' | 'QUIZ' | 'PDP' | 'LIFE_INSURANCE'
  leadgenPopupType?: LeadgenPopupType
  autoCallNowPopup?: boolean
  headerText?: string
  headerButtonText?: string
  useCallNowInHeader?: boolean
  showBannerType?: 'INFO' | 'APPT' | 'NONE'
}

export const Homepage: FC<Props> = (props) => {
  return (
    <StateProvider>
      <Page {...props} />
    </StateProvider>
  )
}
